module.exports = __webpack_public_path__ + "static/media/mobile.7522d627.svg";